import axios from 'axios'

const service = axios.create({
  baseURL: 'http://118.31.111.180:8000',
  timeout: 10000
})

// http request 拦截器
service.interceptors.request.use(
  config => {
    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

// http response 拦截器
service.interceptors.response.use(
  (response) => {
    return response.data
  },
  (err) => {
    return Promise.reject(err)
  }
)

export {
  service as axios
}
